import src from "IMAGE";
export default { src, width: 366, height: 729, blurWidth: 0, blurHeight: 0};
